import { useTranslation } from 'react-i18next';
import { useState, useCallback } from 'react';

const testimonials = [
  { quote: 'testimonials.quote1', name: 'testimonials.name1', location: 'testimonials.location1' },
  { quote: 'testimonials.quote2', name: 'testimonials.name2', location: 'testimonials.location2' },
  { quote: 'testimonials.quote3', name: 'testimonials.name3', location: 'testimonials.location3' },
] as const;

export default function TestimonialSection() {
  const { t } = useTranslation('home');
  const [current, setCurrent] = useState(0);

  const prev = useCallback(() => {
    setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  }, []);

  const next = useCallback(() => {
    setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));
  }, []);

  const item = testimonials[current];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        {/* Section label */}
        <p className="text-sm font-medium text-foreground-500 mb-6 font-heading italic">
          ( {t('testimonials.tag')} )
        </p>

        {/* Rating badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-foreground-900 rounded-full mb-8">
          <i className="ri-star-fill text-accent-400 w-4 h-4 flex items-center justify-center" />
          <span className="text-sm font-semibold text-background-50">{t('testimonials.rating')}</span>
        </div>

        {/* Quote */}
        <blockquote className="mb-8">
          <p className="text-lg md:text-xl text-foreground-800 font-heading leading-relaxed italic">
            &ldquo;{t(item.quote)}&rdquo;
          </p>
        </blockquote>

        {/* User info */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
            <span className="text-sm font-bold text-secondary-700">
              {t(item.name).charAt(0)}
            </span>
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-foreground-900">{t(item.name)}</p>
            <p className="text-xs text-foreground-500">{t(item.location)}</p>
          </div>
        </div>

        {/* Navigation arrows */}
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={prev}
            className="w-9 h-9 rounded-lg border border-foreground-200 flex items-center justify-center text-foreground-600 hover:bg-background-50 transition-colors cursor-pointer"
            aria-label="Depoimento anterior"
          >
            <i className="ri-arrow-left-s-line w-5 h-5 flex items-center justify-center" />
          </button>
          <button
            onClick={next}
            className="w-9 h-9 rounded-lg bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
            aria-label="Próximo depoimento"
          >
            <i className="ri-arrow-right-s-line w-5 h-5 flex items-center justify-center" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-4">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${
                idx === current ? 'bg-primary-500' : 'bg-foreground-200'
              }`}
              aria-label={`Depoimento ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}